import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import '../../assets/scss/ReactSelect.scss';
import { useField } from 'formik';
import FormGroup from './FormGroup';

function AsyncSelectField({ name, label, loadOptions }) {
  const [field,, helpers] = useField(name);

  // Resetovani vlastnich stylu a pouzijeme stylovani pres CSS
  const customStyles = {
    control: () => ({}),
    valueContainer: () => ({}),
    placeholder: () => ({}),
    indicatorSeparator: () => ({}),
    option: () => ({})
  };

  function handleInputChange(option) {
    helpers.setValue(option.value)
  }

  return (
    <FormGroup>
      {label && <label className="input-label" htmlFor={field.name}>{label}</label>}
      <AsyncSelect
        id={field.name}
        name={name}
        isSearchable={false}
        styles={customStyles}
        classNamePrefix="react-select"
        loadOptions={loadOptions}
        placeholder="Vyberte..."
        defaultOptions
        onChange={handleInputChange}
      />
    </FormGroup>
  );
}

AsyncSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  loadOptions: PropTypes.func.isRequired
};

AsyncSelectField.defaultProps = {
  label: null
}

export default AsyncSelectField;
